import { computed, ref, watchEffect } from "vue";
import { calcDesconto } from "@/modules/planos/helpers/calcDesconto";
import { calcPercentual } from "@/modules/planos/helpers/calcPercentual";

/**
 * @typedef {import("vue").Ref<number>} RefNumber
 */

/**
 * @typedef {{ percent: RefNumber, baseValue: RefNumber, finalValue: RefNumber }} TOptionCalc
 */

/**
 * @param {TOptionCalc} options
 * @returns {RefNumber}
 */
export function useCalcDesconto(options) {
  const { percent = ref(0), baseValue = ref(0), finalValue = ref(0) } = options;

  const result = computed({
    get() {
      const { value } = calcDesconto({
        valuePercent: Number(percent.value ?? 0),
        baseValue: Number(baseValue.value ?? 0),
      });

      return value;
    },
    set(value) {
      percent.value = calcPercentual({
        base: Number(baseValue.value ?? 0),
        finalValue: Number(value ?? 0),
      });
    },
  });

  watchEffect(() => {
    finalValue.value = result.value;
  });

  return result;
}
